import { render } from "./EventHome.vue?vue&type=template&id=b4c619ee&scoped=true"
import script from "./EventHome.vue?vue&type=script&lang=js"
export * from "./EventHome.vue?vue&type=script&lang=js"

import "./EventHome.vue?vue&type=style&index=0&id=b4c619ee&scoped=true&lang=css"

import exportComponent from "../../../../../../name-pronunciation/orator-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4c619ee"]])

export default __exports__